Billy.ScheduledInvoice.reopen({
    isRecurringByDate: Em.computed.equal('recurringUnit', 'day')
})
